import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Devuelve una función que resuelve la ruta del Menú Principal del usuario.
// Si no tiene Menú Principal configurado (o no es accesible), regresa el Dashboard (/estructura).
export function useHomeRoute() {
  const { user } = useAuth();
  const { data: menu } = useQuery({
    queryKey: ["menu"],
    queryFn: async () => (await api.get("/menu")).data,
    enabled: !!user,
  });
  return () => {
    const flat = [];
    const walk = (t) => (t || []).forEach((n) => { if (n.route) flat.push(n); walk(n.children); });
    walk(menu || []);
    const byId = Object.fromEntries(flat.map((n) => [n.id, n]));
    const home = user?.home_menu_id ? byId[user.home_menu_id] : null;
    return (home && home.route) || "/estructura";
  };
}
